export const flagTypeMarkerNames = ["markerSelect1", "markerSelect3"];
export const presetMarkerNames = ["markerSelect2", ...flagTypeMarkerNames];

/**
 * @author mjkang
 * @description svg, png 아이콘 import용 공통 인덱스 모듈
 *              svg는 변수에 require(경로).default,
 *              png는 import 구문으로 사용하거나 변수에 require(경로)로 불러서
 *              export하여 사용
 */
const icons: { [key: string]: string } = {
    // CategoryList.tsx | 카테고리 버튼 추가 아이콘
    account: require("./account_circle.svg").default,
    cant_box: require("./cant_box.svg").default,
    enter_blue: require("./enter_blue.svg").default,
    lock: require("./lock.svg").default,
    open_lock: require("./open_lock.svg").default,
    // Marker.tsx 아이콘
    help: require("./help.svg").default,
    plus: require("./add.svg").default,
    minus: require("./remove.svg").default,
    search: require("./search_i.svg").default,
    more: require("./more_vert.svg").default,
    ctprvn: require("./public.svg").default,
    choropleth: require("./grid_on.svg").default,
    chart: require("./chart.svg").default,
    bubble: require("./bubble_chart.svg").default,
    heat: require("./thermostat.svg").default,
    direction: require("./timer.svg").default,
    distance: require("./square_foot.svg").default,
    extent: require("./zoom_out.svg").default,
    addPlace: require("./add_location.svg").default,
    gps: require("./location.svg").default,
    bookmark: require("./bookmark.svg").default,
    favorite: require("./favorite.svg").default,
    chat: require("./chat.svg").default,
    view: require("./visibility.svg").default,
    view_off: require("./visibility_off.svg").default,
    thumbUp: require("./thumb_up.svg").default,
    logoM: require("../logo_m.png"),
    hashtag: require("./hashtag.svg").default,
    travel_explore: require("./travel_explore.svg").default,
    mapAct: require("./map_act.svg").default,
    shareDeAct: require("./share_deact.svg").default,
    sort: require("./sort.svg").default,
    arrowBack: require("./arrow_back.svg").default,
    arrowForward: require("./arrow_forward.svg").default,
    arrow_back: require("./back_arrow.svg").default,
    arrow_play: require("./play_arrow.svg").default,
    close: require("./close.svg").default,
    send: require("./send.svg").default,
    marker: require("./marker.svg").default,
    money: require("./payments.svg").default,
    check: require("./check.svg").default,
    del: require("./delete.svg").default,
    uploadFile: require("./upload_file.svg").default,
    addPhoto2: require("./add_photo_alternate.svg").default,
    errorImg: require("./hide_image.svg").default,
    arrowDown: require("../icon/arrowdown.svg").default,
    arrowUp: require("../icon/arrowup.svg").default,
    [presetMarkerNames[0]]: require("./mk2_select.svg").default,
    [presetMarkerNames[1]]: require("./mk1_select.svg").default,
    [presetMarkerNames[2]]: require("./mk3_select.svg").default,
    mk1_highlight: require("./mk1_highlight.svg").default,
    mk2_highlight: require("./mk2_highlight.svg").default,
    mk3_highlight: require("./mk3_highlight.svg").default,
    link: require("./link.svg").default,
    call: require("./call.svg").default,
    attach_money: require("./attach_money.svg").default,
    format_quote: require("./format_quote.svg").default,
    reset: require("./reset.svg").default,
    formatBold: require("./format_bold.svg").default,
    formatItalic: require("./format_italic.svg").default,
    formatUnderlined: require("./format_underlined.svg").default,
    formatAlignLeft: require("./format_align_left.svg").default,
    formatAlignCenter: require("./format_align_center.svg").default,
    formatAlignRight: require("./format_align_right.svg").default,
    frameSource: require("./frame_source.svg").default,
    dragIndicator: require("./drag_indicator.svg").default,
    addTask: require("./add_task.svg").default,
    alterTask: require("./task_alt.svg").default,
    warn: require("./warning.svg").default,
    convenience: require("./convenience.svg").default,
    cafe: require("./cafe.svg").default,
    restaurant: require("./restaurant.svg").default,
    crownSimple: require("./crown_simple.svg").default,
    circle: require("./adjust.svg").default,
    extentAnalysis: require("./extentAnalysis.svg").default,
    overlap: require("./join.svg").default,
    d_car: require("./directions_car.svg").default,
    d_bike: require("./directions_pedalbike.svg").default,
    d_walk: require("./directions_walk.svg").default,
    slope: require("./slope.svg").default,
    target: require("./target.svg").default,
    markerSelect1: require("./markerSelect1.svg").default,
    markerSelect2: require("./markerSelect2.svg").default,
    markerSelect3: require("./markerSelect3.svg").default,
    imagesmode: require("./imagesmode.svg").default,
    trash: require("./trash.svg").default,
    trash_white: require("./trash_white.svg").default,
    arrowDownRight: require("./arrow-turn-down-right.svg").default,
    alert: require("./alert.svg").default,
    pause: require("./pause.svg").default,
    copy: require("./copy.svg").default,
    complete: require("./complete.svg").default,
    // TODO mjkang 사용하지 않는 아이콘 확인하여 제거할 것(이미지 파일도 제거)
    // addPhoto: require("./add_a_photo.svg").default,
    // globe: require("./globe.svg").default,
    // mapDeAct: require("./map_deact.svg").default,
    // shareAct: require("./share_act.svg").default,
    // markerLarge: require("./marker100.svg").default,
    // edit: require("./edit.svg").default,
    // undo: require("./undo.svg").default,
    // rateReview: require("./rate_review.svg").default,
    // formatColorText: require("./format_color_text.svg").default,
    // download: require("./download.svg").default,
};

export default icons;
